import React, { useMemo } from 'react';

import { Select } from '@gogame/components';
import { withFormField } from '@gogame/form';

const EMPTY_OPTIONS = [];

const EventSelect = withFormField()(
  ({ area, value, onChange, disabled, error, selectedEventsIds = [] }) => {
    const options = useMemo(
      () =>
        area.data?.filter(({ id }) => !selectedEventsIds.includes(id)) ||
        EMPTY_OPTIONS,
      [selectedEventsIds, area.data]
    );

    return (
      <Select
        loading={area.loading}
        options={options}
        value={value?.id}
        error={error?.id || error}
        placeholder={value?.name || 'Select event'}
        disabled={disabled}
        onChange={(e, elId) =>
          onChange(
            e,
            area.data.find(({ id }) => id === elId)
          )
        }
      />
    );
  }
);

export default EventSelect;
